import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';

@Injectable()
export class GlobalService {

  // public static getBuyerHeaders() {
  //   const token = localStorage.getItem('buyertoken');
  //   console.log('token', token);
  //   const headerToken = 'Bearer ' + token;
  //   console.log('hk', headerToken);
  //   const headers = new Headers({ 'Authorization': headerToken , 'Content-Type': 'application/json'});
  //   return new RequestOptions({ headers: headers });
  // }

  // public static getSellerHeaders() {
  //   const token = localStorage.getItem('sellertoken');
  //   console.log('token', token);
  //   const headerToken = 'Bearer ' + token;
  //   console.log('hk', headerToken);
  //   const headers = new Headers({ 'Authorization': headerToken , 'Content-Type': 'application/json'});
  //   return new RequestOptions({ headers: headers });
  // }

  // public static getSellerHeadersWithoutCT() {
  //   const token = localStorage.getItem('sellertoken');
  //   console.log('token', token);
  //   const headerToken = 'Bearer ' + token;
  //   console.log('hk', headerToken);
  //   const headers = new Headers({ 'Authorization': headerToken});
  //   return new RequestOptions({ headers: headers });
  // }

  // public static getBankerHeaders() {
  //   const token = localStorage.getItem('bankertoken');
  //   console.log('token', token);
  //   const headerToken = 'Bearer ' + token;
  //   console.log('hk', headerToken);
  //   const headers = new Headers({ 'Authorization': headerToken, 'Content-Type': 'application/json'});
  //   return new RequestOptions({ headers: headers });
  // }

  public static getBankerHeadersWithoutCT() {
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const headers = new Headers({ 'Authorization': headerToken });
    return new RequestOptions({ headers: headers });
  }


  // public static getBankerHeadersWithoutCT() {
  //   const token = localStorage.getItem('bankertoken');
  //   console.log('token', token);
  //   const headerToken = 'Bearer ' + token;
  //   console.log('hk', headerToken);
  //   const headers = new Headers({ 'Authorization': headerToken , 'Content-Type': 'application/json'});
  //   return new RequestOptions({ headers: headers });
  // }

  // public static getHeaders() {
  //   const token = localStorage.getItem('token');
  //   console.log('token', token);
  //   const headerToken = 'Bearer ' + token;
  //   console.log('hk', headerToken);
  //   const headers = new Headers({ 'Authorization': headerToken , 'Content-Type': 'application/json'});
  //   return new RequestOptions({ headers: headers });
  // }

  public static getHeaders() {
    const token = localStorage.getItem('currentUser');

    const headerToken = 'Bearer ' + token;

    const headers = new Headers({ 'Authorization': headerToken , 
    'Content-Type': 'application/json',   
    'Access-Control-Allow-Origin': '*'});
    return new RequestOptions({ headers: headers });
  }


  public static getInvHeaders() {
    const token = localStorage.getItem('currentUser');

    const headerToken = 'Bearer ' + token;
 
    const headers = new Headers({ 'Authorization': headerToken});
    return new RequestOptions({ headers: headers });
  }

  public static setHeaders() {
    const headers = new Headers({'Content-Type': 'application/json'});
    return new RequestOptions({ headers: headers });
  }

  // public static getTextHeaders() {
  //   const token = localStorage.getItem('token');
  //   console.log('token',token);
  //   const headerToken = 'Bearer ' + token;
  //   console.log('hk',headerToken);
  //   const headers = new Headers({ 'Authorization': headerToken});
  //   return new RequestOptions({ headers: headers });
  // }

}
